class SiteHeaderComponent extends HTMLElement {
  constructor () {
    super()
    this.init()
  }

  init () {
    this.setSelectors()
  }

  setSelectors () {
    this.selectors = {
      account: '[data-header-account]',
      cart: '[data-header-cart]',
      logo: '[data-header-logo]',
      menu: '[data-header-menu]',
      navigation: '[data-header-navigation]',
      search: '[data-header-search]',
      title: '[data-header-title]',
      wishlist: '[data-header-wishlist]',
      cartCount: '[data-header-cart-count]',
      mobileMenu: '[data-header-mobile-menu]',
      searchMobile: '[data-header-search-mobile]',
    }
  }

  setEventListeners () {
    this.elements.cart.addEventListener('click', () => {
      window.cnvs.EventBus.emit('overlay:toggle', {
        component: 'cart-drawer',
        ignoreDismissed: true,
        namespace: 'cartDrawer',
      })
    })

    this.elements.wishlist.addEventListener('click', () => {
      window.cnvs.EventBus.emit('overlay:toggle', {
        component: 'wishlist-list',
        ignoreDismissed: true,
        namespace: 'wishlistDrawer',
      })
    })

    this.elements.mobileMenu.addEventListener('click', () => {
      window.cnvs.EventBus.emit('overlay:toggle', {
        component: 'menu-drawer',
        ignoreDismissed: true,
        namespace: 'menuDrawer',
      })
    })

    this.elements.search.addEventListener('click', () => {
      window.cnvs.EventBus.emit('overlay:toggle', {
        component: 'search-drawer',
        ignoreDismissed: true,
        namespace: 'searchDrawer',
      })
    })

    this.elements.searchMobile.addEventListener('click', () => {
      window.cnvs.EventBus.emit('overlay:toggle', {
        component: 'search-drawer',
        ignoreDismissed: true,
        namespace: 'searchDrawer',
      })
    })

    cnvs.EventBus?.listen('cart:update', () => {
      fetch(cnvs.routes.cart.js)
        .then(response => response.json())
        .then(data => {
          if (data.item_count > 0) {
            this.elements.cartCount.innerHTML = data.item_count
          } else {
            this.elements.cartCount.innerHTML = ''
          }
        })
    })
  }

  connectedCallback () {
    // Wait for DOM to be ready
    requestAnimationFrame(() => {
      // Get DOM elements using selectors
      this.elements = {}
      for (const [key, selector] of Object.entries(this.selectors)) {
        this.elements[key] = document.querySelector(selector)
      }
      this.setEventListeners()
    })
  }
}

if (!customElements.get('site-header-component')) {
  customElements.define('site-header-component', SiteHeaderComponent)
}
